import axios from "axios";
import systemUserIntegration from "./self-service-system-adapter";
const api = systemUserIntegration("/ecommerce-products/v3");
import omniChannelApi from "./oneshop-adapter";
import type {
	ReserveAndCollectRequest,
	ReserveAndCollectResponse,
	ReserveAndCollectResult,
} from "~/components/ecommerce/types/clickAndCollect";

const getStoresWithProduct = async (
	ean: string,
	latitude?: number,
	longitude?: number,
	includeZeroInventory?: boolean,
	limit: number = 100,
) => {
	const url = omniChannelApi(`v2/dealers/inventory/${ean}`);
	const params: Record<string, any> = {};
	params.limit = limit;

	if (latitude !== undefined && latitude !== null && longitude !== undefined && longitude !== null) {
		// Only add latitude and longitude if they are valid values
		if (latitude !== 0.0 || longitude !== 0.0) {
			params.lat = latitude.toString();
			params.lon = longitude.toString();
		}
	}
	if (includeZeroInventory) {
		params.includeZeroInventory = includeZeroInventory;
	}

	const { data } = await axios.get(url, { params });
	return data;
};

const searchForStoresWithProductByPlacenameOrPostnumber = async (ean: string, query: string) => {
	const url =
		query != null
			? omniChannelApi(`v2/dealers/inventory/${ean}?query=${query}`)
			: omniChannelApi(`v2/dealers/inventory/${ean}`);
	try {
		const { data } = await axios.get(url);
		return data;
	} catch (e) {
		console.log(e);
		return null;
	}
};

const reserveProduct = async (data: ReserveAndCollectRequest): Promise<ReserveAndCollectResult> => {
	const url = omniChannelApi(`v1/dealers/inventory/reservation`);
	try {
		const response: ReserveAndCollectResponse = await api.post(url, data);
		return { success: true, data: response };
	} catch (e: any) {
		console.error(e);

		const statusCode = e?.response?.status || 500;
		const message = e?.response?.data?.message || e?.message || "Unknown error occurred while reserving product.";

		return {
			success: false,
			error: {
				statusCode,
				message,
			},
		};
	}
};

const checkAvailability = async (hardwareProductId) =>
	await api.get(`/products/${hardwareProductId}/dealers/availability`);

export default {
	getStoresWithProduct,
	reserveProduct,
	checkAvailability,
	searchForStoresWithProductByPlacenameOrPostnumber,
};
